import Vue from 'vue';
import purchaseTransformer from './../../transformers/purchase';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('RefreshStockProductsCustom');
  store.dispatch('fetchCurrentPurchase', purchaseTransformer.fetch(data));
  resolve(purchaseTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(purchaseTransformer.fetch(errors));
};

export default (id, purchase) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/purchases/update-draft/${id}`, purchase)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/updateDraft.js